import React from 'react';
import CustomTable from '../../../../../components/table/CustomTable';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import {
    actions,
    formatColumnTitle,
    getPermissionModuleId,
    privilegesPlatforms,
    SPECIAL_PERMISSIONS,
} from '../Model/AllowedModules';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
import CustomTooltip from '../../../../../components/CustomTooltip';
import {
    IconCheckbox,
    IconCheckboxChecked,
    IconCheckboxUnchecked,
} from '../../../../../components/buttons/IconButtons';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

const SummaryTable = ({ module, roleListData, selectedPermissions, t, platform = 'web' }) => {
    const tableId = 'tbl_st_table';
    const MOBILE_PLATFORM = privilegesPlatforms[0].id;
    const isMobile = platform === MOBILE_PLATFORM;

    // The summary only lists what the role grants, so unselected permissions are left out
    const selectedIds = new Set((selectedPermissions || []).map((item) => item.id));
    const modulePermissions = (roleListData || []).filter(
        (role) =>
            selectedIds.has(role.id) &&
            module.children?.some((child) => child.id === getPermissionModuleId(role)) &&
            role.isMobileApp === isMobile,
    );
    // Rows without any granted permission add no information
    const moduleChildren = (module.children || []).filter((child) =>
        modulePermissions.some((permission) => getPermissionModuleId(permission) === child.id),
    );

    const moduleColumns =
        modulePermissions.length > 0
            ? [
                  ...new Set(
                      modulePermissions.map((permission) => {
                          if (SPECIAL_PERMISSIONS.includes(permission.name)) {
                              return permission.name;
                          }

                          const matchedAction = actions.find((action) =>
                              permission.name.toLowerCase().includes(action.toLowerCase()),
                          );

                          return matchedAction || permission.name;
                      }),
                  ),
              ]
            : [];

    const thead = [
        <CustomTh tableId={tableId} key='module' />,

        ...moduleColumns.map((column) => (
            <CustomTh tableId={tableId} key={column}>
                <CustomTooltip text={formatColumnTitle(t(column))}>
                    <div className='text-center text-capitalize'>{formatColumnTitle(t(column))}</div>
                </CustomTooltip>
            </CustomTh>
        )),
    ];

    const tbody = {
        data: moduleChildren,
        body: moduleChildren.map((child) => {
            const childPermissions = modulePermissions.filter(
                (permission) => getPermissionModuleId(permission) === child.id,
            );

            return (
                <>
                    <CustomTd tableId={tableId}>
                        <p className='fs-12px font-color-text-950 ibl-font-w-600'>{t(child.translation)}</p>
                    </CustomTd>

                    {moduleColumns.map((column) => {
                        const permission = childPermissions.find((permission) => {
                            if (actions.includes(column) && !SPECIAL_PERMISSIONS.includes(permission.name)) {
                                return permission.name.toLowerCase().includes(column.toLowerCase());
                            }

                            return permission.name === column;
                        });

                        return (
                            <CustomTd key={`${child.id}-${column}`} tableId={tableId} className='text-end'>
                                <div className='d-flex justify-content-center align-items-center'>
                                    <CustomCheckbox
                                        icon={
                                            !permission ? (
                                                <IconCheckbox />
                                            ) : (
                                                <IconCheckboxUnchecked className='icon-color-general-950' />
                                            )
                                        }
                                        checkedIcon={
                                            !permission ? (
                                                <IconCheckbox />
                                            ) : (
                                                <IconCheckboxChecked className='icon-color-shades-800' />
                                            )
                                        }
                                        checked={
                                            permission
                                                ? selectedPermissions.some((item) => item.id === permission.id)
                                                : false
                                        }
                                        onChange={() => {}}
                                    />
                                </div>
                            </CustomTd>
                        );
                    })}
                </>
            );
        }),
    };

    return (
        <CustomTable
            tableId={tableId}
            searchId={`${tableId}_search`}
            thead={thead}
            tbody={tbody}
            checkbox={false}
            columnActions={false}
            withoutHeight={true}
        />
    );
};

export default SummaryTable;
